import { useState, useEffect } from 'react';
import { detectPlatform, PlatformInfo } from '../utils/platformUtils';

export const usePlatform = (): PlatformInfo => {
  const [platform, setPlatform] = useState<PlatformInfo>(detectPlatform);

  useEffect(() => {
    const handleResize = () => {
      setPlatform(detectPlatform());
    };

    const handleOrientationChange = () => {
      // Small delay to ensure dimensions are updated after orientation change
      setTimeout(() => {
        setPlatform(detectPlatform());
      }, 100);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  return platform;
};